export default function findMaxOrEqualDate(d1: string | number, d2: string | number) {
  let date1 = (typeof d1 === 'number') ? d1 : new Date(d1).getTime();
  let date2 = (typeof d2 === 'number') ? d2 : new Date(d2).getTime();
  console.log("date1 date2 >", date1, date2)
  if (date1 > date2) {
    return 1;
  } else if (date1 < date2) {
    return 2;
  } else {
    return 3;
  }
}